var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil-alt",
    d: "M13.638,3.959,12.377,5.219a.328.328,0,0,1-.465,0L8.877,2.184a.328.328,0,0,1,0-.465L10.138.459a1.315,1.315,0,0,1,1.857,0L13.638,2.1A1.31,1.31,0,0,1,13.638,3.959ZM7.794,2.8.614,9.983l-.58,3.322a.657.657,0,0,0,.76.76l3.322-.582L11.3,6.3a.328.328,0,0,0,0-.465L8.262,2.8a.332.332,0,0,0-.468,0ZM3.417,9.367a.381.381,0,0,1,0-.541L7.628,4.615a.383.383,0,0,1,.541.541L3.958,9.367a.381.381,0,0,1-.541,0Zm-.987,2.3H3.742v.993l-1.764.309-.85-.85.309-1.764h.993Z",
    transform: "translate(-0.024 -0.075)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.90c3639090648b83d04d8ed4d6acb49a.svg";
export { ForwardRef as ReactComponent };